<template>
  <va-card title="Main Slider">
    <va-button
      :to="{ name: '1lk-home-slider-edit'}"
    >
      Створити
    </va-button>
    <va-data-table
      :fields="fields"
      :data="items"
      no-pagination
    >
      <template slot="marker" slot-scope="props">
        <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
      </template>

      <template slot="translations" slot-scope="props">
        <va-badge color="info" :outline="!translation.status" v-for="(translation, index) in props.rowData.trans" :key="index">{{ translation.locale }}</va-badge>
      </template>

      <template slot="toggle" slot-scope="props">
        <va-toggle
          small
          v-on:input="togglePublished(props.rowData.id)"
          v-model="props.rowData.published"
        />
      </template>

      <template slot="actions" slot-scope="props">
        <va-button
          small
          color="info"
          :to="{ name: '1lk-home-slider-edit', params: { id: props.rowData.id } }"
        >
          Редагувати
        </va-button>
        <va-button
          @click="remove(props.rowData.id)"
          small
          color="danger"
          class="ma-0">
          Видалити
        </va-button>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  data () {
    return {
      items: [],
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    fields () {
      return [{
        name: 'label',
        title: 'Label',
        width: '25%',
      },
      {
        name: 'button_label',
        title: 'Button label',
        width: '10%',
      },
      {
        name: 'button_link',
        title: 'Button link',
        width: '10%',
      },
      {
        name: 'position',
        title: 'Позиція',
        width: '10%',
      },
      {
        title: 'Опубліковано',
        name: '__slot:toggle',
        width: '20%',
      },
      {
        title: 'Переклади',
        name: '__slot:translations',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    locale () {
      return Vue.i18n.locale()
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    togglePublished (id) {
      axios.put(`${process.env.VUE_APP_1LK_API_URL}/admin/main-slider/${id}`, {
        published: this.items.find((item) => item.id === id).published ? 1 : 0,
      })
        .then(response => {
          this.showToast('Success')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    remove (id) {
      if (confirm('Дійсно видалити?')) {
        axios.delete(`${process.env.VUE_APP_1LK_API_URL}/admin/main-slider/${id}`)
          .then(response => {
            const idx = this.items.findIndex(u => u.id === id)
            this.items.splice(idx, 1)
            this.showToast('Success')
          })
          .catch(error => {
            console.log(error)
            this.showToast('Error')
          })
      }
    },
    fetch () {
      axios.get(`${process.env.VUE_APP_1LK_API_URL}/admin/main-slider?lang=${this.locale}`)
        .then(response => {
          console.log(response.data)
          this.items = response.data
          this.items.forEach((item) => {
            item.published = !!item.published
          })
        })
        .catch(error => {
          console.log(error.response)
        })
    },
  },
}
</script>

<style lang="scss">
</style>
